import { DialogComponent } from '@theme/dialog';
import { CartAddEvent, CartUpdateEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.addEventListener('click', this.#handleUpsellClick);  // Attach upsell handler scoped to the drawer
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener('click', this.#handleUpsellClick);  // Clean up
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  #handleUpsellClick = async (event) => {
    const button = event.target.closest('.upsell-add');
    if (!button) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.classList.add('loading');

    try {
      // Add the upsell item
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      // Fetch the updated cart data
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // Dispatch CartUpdateEvent to refresh the drawer (Horizon-specific)
      const updateEvent = new CartUpdateEvent(cart, 'manual-trigger', {
        itemCount: cart.item_count,
        source: 'upsell-refresh',
        sections: {}
      });
      document.dispatchEvent(updateEvent);

      // Optional: If needed, open the drawer (but if upsell is inside, it's likely already open)
      // if (this.hasAttribute('auto-open')) {
      //   this.showDialog();
      // }

    } catch (error) {
      console.error('Upsell add failed', error);
    } finally {
      button.classList.remove('loading');
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}